module.exports = __webpack_public_path__ + "img/MED.24ae9417.svg";